<script setup>
const props = defineProps({
  time: String,
  required: true,
})
const { d } = useI18n()
</script>

<template>
  <div
    class="row-header w-a b-1 b-surface-600 bg-surface-300 px-5 py-2 text-black fw-semibold"
  >
    {{ d(time, 'time').toLowerCase() }}
  </div>
</template>
